export default __webpack_public_path__ + "static/media/error-outline.73a60752.svg";